import { GET_LAYOUT_PRESETS } from "constants/layoutPresets";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_LAYOUT_PRESETS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
